import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/useTheme";

export const ThemeToggle = ({ variant = "desktop" }) => {
  const { theme, toggle } = useTheme();
  return (
    <button
      data-testid={`theme-toggle-${variant}`}
      onClick={toggle}
      aria-label="Toggle theme"
      className="brut-border brut-shadow-sm brut-hover bg-background h-10 w-10 flex items-center justify-center"
    >
      {theme === "dark" ? (
        <Sun className="w-5 h-5" strokeWidth={2.5} />
      ) : (
        <Moon className="w-5 h-5" strokeWidth={2.5} />
      )}
    </button>
  );
};
